export default __webpack_public_path__ + "static/media/support.8bfc28ba.svg";